import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output
} from "@angular/core";
import { Router } from "@angular/router";
import { Subscription } from "rxjs";
import { RoutingPath } from "src/app/configs/routing-path";
import { LocalStorageService } from "src/app/core/services/local-storage/local-storage.service";
import { RequestService } from "src/app/core/services/request/request.service";
import { environment } from "src/environments/environment";
import { IAfiliado } from "../../core/models/user/user";
import { NotificationService } from "../../core/services/notification/notification.service";

@Component({
  selector: "app-notify",
  templateUrl: "./notify.component.html",
  styleUrls: ["./notify.component.scss"],
})
export class NotifyComponent implements OnInit, OnDestroy {
  public jwTokenData: any;
  public afiliate: IAfiliado;
  public counterRequest = 0;
  public counterRequestDefault: number = 0;
  public menu: any;
  prePage: string;
  prePageDefault: string;
  subscription: Subscription;
  public dropActive = false;

  @Output() overlayActive: EventEmitter<boolean>;

  constructor(
    public _changeDetector: ChangeDetectorRef,
    public requestService: RequestService,
    private notificationService: NotificationService,
    private router: Router,
    private _storage: LocalStorageService,
  ) {
    this.overlayActive = new EventEmitter();
  }

  ngOnInit() {
    let notification: [] = this._storage.parseItem("notification");

    let businessInformationStorage = localStorage.getItem(
      environment.LOCAL_STORAGE.BUSINESS_INFORMATION
    );
    let empresaData = JSON.parse(businessInformationStorage);
    let userloggedin = JSON.parse(localStorage.getItem("userloggedin"));

    let typeDocumentBusiness = empresaData.tipoDocumento;
    let numberDocumentBusiness = userloggedin.docNumberCompany;

    let params = {
      isRectificableCase: true,
      portal: 2,
    };

    this.requestService
      .getRequestsNotify(numberDocumentBusiness, typeDocumentBusiness, params)
      .subscribe((data) => {   
        if (data.body) {
          this.counterRequestDefault = data.body.length;
        }
        this.requestService.obtenerDocumentosDevueltos(numberDocumentBusiness).subscribe((transformedData) => {
          this.counterRequestDefault += transformedData.length;
        });
      });

    if (notification === undefined || notification === null) {
      this.notificationService.getNotify().subscribe((d) => {
        if (d !== undefined) {
          this.counterRequest = d+1;
        }
      });
    }
    this.counterRequest = notification != null ? notification.length : 0;

    this.prePage = `${RoutingPath.appRouting.components.subsidy.path}/`;
    this.prePage +=
      RoutingPath.appRouting.components.subsidy.pages.notifications.path;
    this.prePageDefault = `${RoutingPath.appRouting.components.individual_retreat.path}/`;
    this.prePageDefault +=
      RoutingPath.appRouting.components.individual_retreat.pages.list_request.path;
    this.menu = document.getElementsByClassName("mat-menu-panel");
  }

  ngOnDestroy() {
    // unsubscribe to ensure no memory leaks
    //this.subscription.unsubscribe();
  }

  goToNewsDefault() {
    this.router.navigateByUrl(this.prePageDefault);
  }

  goToNews() {
    this.router.navigateByUrl(this.prePage);
    this.hiddeToggle();
  }

  show(event: any) {
    this.dropActive = !this.dropActive;
    this.overlayActive.emit(this.dropActive);
    let expand = this.dropActive ? "true" : "false";
  }

  close() {
    if (this.menu[0] != undefined)
      this.menu[0].parentElement.style.visibility = "collapse";
  }

  hiddeToggle() {
    this.dropActive = !this.dropActive;
  }
}
